import React from "react";

const VikasKame = () => {
  // Internal CSS Styles
  const styles = {
    container: {
      maxWidth: '800px',
      margin: '20px auto',
      padding: '25px',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#e9f5ff', // Light Blue/Sky Background for Water Theme
      borderRadius: '10px',
      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
    },
    title: {
      textAlign: 'center',
      fontSize: '28px',
      color: '#0056b3', // Deep Blue
      borderBottom: '4px solid #0056b3',
      paddingBottom: '10px',
      marginBottom: '20px',
      fontWeight: '700',
    },
    sectionTitle: {
      fontSize: '22px',
      color: '#007bff', // Medium Blue
      marginTop: '25px',
      marginBottom: '10px',
      paddingLeft: '10px',
      borderLeft: '5px solid #28a745', // Green Highlight
    },
    paragraph: {
      fontSize: '16px',
      lineHeight: '1.7',
      color: '#333',
      padding: '5px 0',
      textAlign: 'justify',
    },
    highlightBox: {
      backgroundColor: '#ffffff',
      padding: '15px',
      borderRadius: '8px',
      border: '1px solid #cce5ff',
      marginTop: '15px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
    },
    list: {
      listStyleType: 'none',
      paddingLeft: '0',
    },
    listItem: {
      fontSize: '16px',
      padding: '8px 0',
      borderBottom: '1px dashed #ddd',
      color: '#555',
    },
    keyAchievement: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#28a745', // Green for positive impact
      padding: '10px',
      backgroundColor: '#d4edda', // Light Green Background
      borderRadius: '6px',
      marginTop: '15px',
      textAlign: 'center',
    },
    thanks: {
      marginTop: '30px',
      padding: '15px',
      backgroundColor: '#fff3cd', // Yellow Background for Thanks
      border: '1px solid #ffeeba',
      borderRadius: '6px',
      textAlign: 'center',
      fontSize: '17px',
      fontWeight: '600',
      color: '#856404',
    },
    // New Style for Daily Works
    dailyWorkList: {
        listStyleType: 'disc',
        paddingLeft: '20px',
    },
    dailyWorkItem: {
        fontSize: '16px',
        marginBottom: '8px',
        color: '#333',
        fontWeight: '500',
    }
  };

  return (
    <div style={styles.container}>
      
      <h2 style={styles.title}>
        💧 ग्रामपंचायत सायकी येथे **जलसंधारणाची कामे प्रगती पथावर** 💧
      </h2>

      <div style={styles.highlightBox}>
        <h3 style={styles.sectionTitle}>
          ✅ **मोहिमेची सुरुवात व नियोजन**
        </h3>
        
        <p style={styles.paragraph}>
          ग्राम पंचायत सायकी येथे शिवार फेरी करून विविध जलसंधारण कामाची **पाहणी व नोंद** घेण्यात आली. भौगोलिक परिस्थिती नुसार विविध उपक्रम व जलसंधारनाचे कामे हाती घेऊन प्रत्येक्ष कामाला सुरुवात करण्यात आली.
        </p>

        <h4 style={{...styles.sectionTitle, borderLeft: '5px solid #ffc107', fontSize: '18px'}}>
            📝 **नियोजनाचे टप्पे**
        </h4>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            **➡️ नानाजी देशमुख कृषी संजीवनी प्रकल्पात** सहभागी होऊन **ग्रामसभा** घेऊन जलसंधारण आराखडा तयार करण्यात आला.
          </li>
          <li style={styles.listItem}>
            **➡️ माती नमुने** घेऊन परीक्षण करण्यात आले.
          </li>
          <li style={styles.listItem}>
            **➡️ पाऊस पाणी ताळेबंद** (वॉटर बजेट) तयार करून **दर्शनी भागी** प्रसिद्ध करण्यात आले.
          </li>
          <li style={styles.listItem}>
            **➡️** सायकी अंतर्गत असलेल्या **जलसंधारनाचे स्रोत** (उदा. विहिरी) दुरुस्त करण्यात आले.
          </li>
        </ul>
      </div>

      <div style={styles.highlightBox}>
        <h3 style={styles.sectionTitle}>
          🛠️ **हाती घेतलेले प्रमुख जलसंधारण प्रकल्प**
        </h3>
        <p style={styles.paragraph}>
          **विहीर पुनर्भरण** आणि **पाऊस पाणी संकलन प्रकल्प** यशस्वीरित्या राबविण्यात आले.
        </p>
        <p style={styles.paragraph}>
          **मुख्यमंत्री समृद्ध पंचायत राज अभियानात** विविध **कोल्हापूरी बंधाऱ्याच्या लोखंडी पाट्या** टाकून जलसंवर्धन करण्यात आले. यासाठी संबंधित विभागाचे मोलाचे मार्गदर्शन व सहकार्य लाभले.
        </p>
      </div>

      {/* NEW SECTION: Daily Works and Facilities */}
      <div style={styles.highlightBox}>
        <h3 style={styles.sectionTitle}>
          🏘️ **ग्रामपंचायतीची दैनंदिन कामे व सुविधा**
        </h3>
        <ul style={styles.dailyWorkList}>
          <li style={styles.dailyWorkItem}>
            **✅ दिवाबत्ती व्यवस्थापन (Street Lamps):** गाव व वस्तीतील **सर्व पथदिवे** (स्ट्रीट लाईट) नियमितपणे सुरु ठेवणे आणि **दुरुस्ती** करणे.
          </li>
          <li style={styles.dailyWorkItem}>
            **✅ नालेसफाई आणि स्वच्छता:** पावसाळ्यापूर्वी **नाले, गटारे आणि ड्रेनेज** व्यवस्था साफ करणे व कचऱ्याची योग्य विल्हेवाट लावणे.
          </li>
          <li style={styles.dailyWorkItem}>
            **✅ सार्वजनिक पाणीपुरवठा:** **नियमित आणि पुरेसा पिण्याच्या पाण्याचा पुरवठा** करणे व जलस्रोतांचे शुद्धीकरण करणे.
          </li>
          <li style={styles.dailyWorkItem}>
            **✅ पाणंद/शेत रस्ते:** शेतातील माल वाहतुकीसाठी **पाणंद रस्ते** सुस्थितीत ठेवणे व नवीन रस्त्यांची निर्मिती करणे.
          </li>
          <li style={styles.dailyWorkItem}>
            **✅ गाव विकास योजना:** **स्वच्छता, आरोग्य, शिक्षण** आणि महिला व बालकल्याण यांसारख्या योजनांची प्रभावी अंमलबजावणी करणे.
          </li>
        </ul>
      </div>
      {/* END OF NEW SECTION */}

      <div style={styles.highlightBox}>
        <h3 style={styles.sectionTitle}>
          📈 **कामाचे सकारात्मक परिणाम**
        </h3>
        
        <p style={styles.keyAchievement}>
          **✅ शेतकऱ्यांना दुबार पीक घेणे शक्य झाले आहे!**
        </p>
        <p style={styles.keyAchievement}>
          **✅ जमिनीत पाण्याची पातळी वाढून विहिरीचे पाणी वाढले आहे!**
        </p>
      </div>
      
      {/* Thanks Section */}
      <p style={styles.thanks}>
        या संपूर्ण मोहिमेत सहभागी **ग्रामवाशी बंधू भगिनी, तरुण, पदाधिकारी, विविध समितीचे सदस्य, अधिकारी आणि कर्मचारी** यांचे ग्राम पंचायत अधिकारी **श्री राजू शेंदरे** यांनी **आभार** व्यक्त केले. 🙏
      </p>

    </div>
  );
};

export default VikasKame;